<template>
  <li v-show="isMenuItemVisible" class="mt-1">
    <!-- <div v-if="hasSubMenu" class="flex justify-between">
      <span
        class="text-sm text-slate-700 dark:text-slate-200 font-semibold my-2 px-2 pt-1 color-blue"
      >
        {{ $t(`SIDEBAR.${menuItem.label}`) }}
      </span>
      <div v-if="menuItem.showNewButton" class="flex items-center">
        <woot-button
          size="tiny"
          variant="clear"
          color-scheme="secondary"
          icon="add"
          class="p-0 ml-2 color-blue"
          @click="onClickOpen"
        />
      </div>
    </div> -->
    <div v-if="hasSubMenu" class="flex justify-between items-center cursor-pointer dark:bg-slate-700 rounded-lg" :class="{'add-background': showSubMenu}" @click.stop="toggleSubMenu">
  <div class="flex items-center">
    <fluent-icon
    v-if="showSubMenu"
     menuItem
      color-scheme="secondary"
      icon="dropdown-menu" 
      class="icon icon--font pos"
      size="18"
 
    />
    <fluent-icon
    v-else
      
      color-scheme="secondary"
      icon="dropup-menu" 
      class="icon icon--font"
      size="20"
     
    />
    <span
      class="text-sm text-slate-700 dark:text-slate-200 font-semibold my-2 px-2 pt-1 color-blue cursor-pointer"
      @click.stop="toggleSubMenu"
    >
      {{ $t(`SIDEBAR.${menuItem.label}`) }}
    </span>
  </div>

  <div class="mr-1.5" @click.stop="toggleSubMenu">
    <fluent-icon
      v-if="showSubMenu"
      icon="subtract" 
      class="icon icon--font"
      size="14"
    />
    <fluent-icon
      v-else
      icon="add" 
      class="icon icon--font"
      size="14"
    />
  </div>
</div>

    <router-link
      v-else
      class="rounded-lg leading-4 font-medium flex items-center p-2 m-0 text-sm text-slate-700 dark:text-slate-100 hover:bg-slate-25 dark:hover:bg-slate-800 color-blue"
      :class="computedClass"
      :to="menuItemTo"
      :exact="shouldUseExactActiveMatch"
      active-class="active-class"
      @click.native="handleMenuItemClick"

    >
      <fluent-icon
        :icon="menuItem.icon"
        class="min-w-[1rem] mr-1.5 rtl:mr-0 rtl:ml-1.5"
       :size="menuItem && (menuItem.icon === 'arrow-trending-lines' || menuItem.icon === 'chat') ? 12 : 14"
       :viewBox="getViewBox(menuItem.icon)"
      />
      {{ $t(`SIDEBAR.${menuItem.label}`) }}
      <span
        v-if="showChildCount(menuItem.count)"
        class="rounded-md text-xxs font-medium mx-1 py-0 px-1"
        :class="{
          'text-slate-300 dark:text-slate-600': isCountZero && !isActiveView,
          'text-slate-600 dark:text-slate-50': !isCountZero && !isActiveView,
          'bg-woot-75 dark:bg-woot-200 text-woot-600 dark:text-woot-600':
            isActiveView,
          'bg-slate-50 dark:bg-slate-700': !isActiveView,
        }"
      >
        {{ `${menuItem.count}` }}
      </span>
      <span
        v-if="menuItem.beta"
        data-view-component="true"
        label="Beta"
        class="px-1 mx-1 inline-block font-medium leading-4 border border-green-400 text-green-500 rounded-lg text-xxs"
      >
        {{ $t('SIDEBAR.BETA') }}
      </span>
    </router-link>

    <!-- <ul v-if="hasSubMenu" class="list-none ml-0 mb-0">
      <secondary-child-nav-item
        v-for="child in menuItem.children"
        :key="child.id"
        :to="child.toState"
        :label="child.label"
        :label-color="child.color"
        :should-truncate="child.truncateLabel"
        :icon="computedInboxClass(child)"
        :warning-icon="computedInboxErrorClass(child)"
        :show-child-count="showChildCount(child.count)"
        :child-item-count="child.count"
      />
      <router-link
        v-if="showItem(menuItem)"
        v-slot="{ href, navigate }"
        :to="menuItem.toState"
        custom
      >
        <li class="pl-1">
          <a :href="href">
            <woot-button
              size="tiny"
              variant="clear"
              color-scheme="secondary"
              icon="add"
              @click="e => newLinkClick(e, navigate)"
            >
              {{ $t(`SIDEBAR.${menuItem.newLinkTag}`) }}
            </woot-button>
          </a>
        </li>
      </router-link>
    </ul> -->
    <ul v-if="showSubMenu" class="list-none ml-0 mb-0">
      <secondary-child-nav-item
        v-for="child in menuItem.children"
        :key="child.id"
        :to="child.toState"
        :label="child.label"
        :label-color="child.color"
        :should-truncate="child.truncateLabel"
        :icon="computedInboxClass(child)"
        :warning-icon="computedInboxErrorClass(child)"
        :show-child-count="showChildCount(child.count)"
        :child-item-count="child.count"
        :board-id="child.boardId"
        :parent-label="menuItem.label"
        :automation="child.automation"
        :contact-automation="child.contactAutomation"
        :exclude-from-default-views="child.excludeFromDefaultViews"
        @child-click="onChildClick"
      />
      <router-link
        v-if="showItem(menuItem)"
        v-slot="{ href, navigate }"
        :to="menuItem.toState"
        custom
      >
        <li class="pl-1">
          <a :href="href">
            <woot-button
              size="tiny"
              variant="clear"
              color-scheme="secondary"
              icon="add"
              @click="e => newLinkClick(e, navigate)"
            >
              {{ $t(`SIDEBAR.${menuItem.newLinkTag}`) }}
            </woot-button>
          </a>
        </li>
      </router-link>
    </ul>
  </li>
</template>

<script>
import { mapGetters } from 'vuex';

import adminMixin from '../../../mixins/isAdmin';
import uiSettingsMixin from 'dashboard/mixins/uiSettings';
import {
  getInboxClassByType,
  getInboxWarningIconClass,
} from 'dashboard/helper/inbox';

import SecondaryChildNavItem from './SecondaryChildNavItem';
import {
  isOnMentionsView,
  isOnUnattendedView,
} from '../../../store/modules/conversations/helpers/actionHelpers';

export default {
  components: { SecondaryChildNavItem },
  mixins: [adminMixin, uiSettingsMixin],
  props: {
    menuItem: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      showSubMenu: true, // Add this data property
    };
  },
  computed: {
    ...mapGetters({
      activeInbox: 'getSelectedInbox',
      accountId: 'getCurrentAccountId',
      isFeatureEnabledonAccount: 'accounts/isFeatureEnabledonAccount',
      globalConfig: 'globalConfig/get',
    }),
    isCountZero() {
      return this.menuItem.count === 0;
    },
    isActiveView() {
      return this.computedClass.includes('active-view');
    },
    hasSubMenu() {
      return !!this.menuItem.children;
    },
    isMenuItemVisible() {
      if (this.menuItem.globalConfigFlag) {
        return !!this.globalConfig[this.menuItem.globalConfigFlag];
      }
      if (this.menuItem.featureFlag) {
        return this.isFeatureEnabledonAccount(
          this.accountId,
          this.menuItem.featureFlag
        );
      }
      return true;
    },
    isAllConversations() {
      return (
        this.$store.state.route.name === 'inbox_conversation' &&
        this.menuItem.toStateName === 'home'
      );
    },
    isMentions() {
      return (
        isOnMentionsView({ route: this.$route }) &&
        this.menuItem.toStateName === 'conversation_mentions'
      );
    },
    isUnattended() {
      return (
        isOnUnattendedView({ route: this.$route }) &&
        this.menuItem.toStateName === 'conversation_unattended'
      );
    },
    isTeamsSettings() {
      return (
        this.$store.state.route.name === 'settings_teams_edit' &&
        this.menuItem.toStateName === 'settings_teams_list'
      );
    },
    isInboxSettings() {
      return (
        this.$store.state.route.name === 'settings_inbox_show' &&
        this.menuItem.toStateName === 'settings_inbox_list'
      );
    },
    isIntegrationsSettings() {
      return (
        this.$store.state.route.name === 'settings_integrations_webhook' &&
        this.menuItem.toStateName === 'settings_integrations'
      );
    },
    isApplicationsSettings() {
      return (
        this.$store.state.route.name === 'settings_applications_integration' &&
        this.menuItem.toStateName === 'settings_applications'
      );
    },
    menuItemTo() {
      if (!this.menuItem?.toState) return '';

      if (this.menuItem.linkQuery) {
        return { path: this.menuItem.toState, query: this.menuItem.linkQuery };
      }

      return this.menuItem.toState;
    },
    shouldUseExactActiveMatch() {
      // Avoid highlighting All Contacts / All Conversations on segment or folder routes.
      return ['contacts_dashboard', 'home'].includes(this.menuItem?.toStateName);
    },
    isCurrentRoute() {
      const routeName = this.$store.state.route.name;
      const targetName = this.menuItem.toStateName;

      if (this.shouldUseExactActiveMatch) {
        return routeName === targetName;
      }

      // Use exact match or prefix match (with underscore separator) to avoid
      // false positives like 'pipeline_boards' matching 'board'
      return routeName === targetName || routeName.startsWith(targetName + '_');
    },

    computedClass() {
      // If active inbox is present, do not highlight conversations
      if (this.activeInbox) return ' ';
      if (
        this.isAllConversations ||
        this.isMentions ||
        this.isUnattended ||
        this.isCurrentRoute
      ) {
        return 'bg-woot-25 dark:bg-slate-800 text-woot-500 dark:text-woot-500 hover:text-woot-500 dark:hover:text-woot-500 active-view active-class';
      }
      if (this.hasSubMenu) {
        if (
          this.isTeamsSettings ||
          this.isInboxSettings ||
          this.isIntegrationsSettings ||
          this.isApplicationsSettings
        ) {
          return 'bg-woot-25 dark:bg-slate-800 text-woot-500 dark:text-woot-500 hover:text-woot-500 dark:hover:text-woot-500 active-view active-class';
        }
        return 'hover:text-slate-700 dark:hover:text-slate-100';
      }

      return 'hover:text-slate-700 dark:hover:text-slate-100';
    },
  },
  methods: {
    computedInboxClass(child) {
      const { type, phoneNumber } = child;
      if (!type) return '';
      const classByType = getInboxClassByType(type, phoneNumber);
      return classByType;
    },
    computedInboxErrorClass(child) {
      const { type, reauthorizationRequired } = child;
      if (!type) return '';
      const warningClass = getInboxWarningIconClass(
        type,
        reauthorizationRequired
      );
      return warningClass;
    },
    newLinkClick(e, navigate) {
      if (this.menuItem.newLinkRouteName) {
        navigate(e);
        console.log('Navigating to new link:', this.menuItem.newLinkRouteName);
      } else if (this.menuItem.showModalForNewItem) {
        if (this.menuItem.modalName === 'AddLabel') {
          e.preventDefault();
          this.$emit('add-label');
        }else if(this.menuItem.modalName === 'AddBoard'){
          e.preventDefault();
          this.$emit('add-board');
        }
      }
    },
    showItem(item) {
      return this.isAdmin && !!item.newLink;
    },
    onClickOpen() {
      this.$emit('open');
    },
    showChildCount(count) {
      return Number.isInteger(count);
    },
    toggleSubMenu() {
      this.showSubMenu = !this.showSubMenu; 
    },
    getViewBox(icon){
        if(icon === 'chat'){
          return '0 0 24 30'
        }
        if(icon === 'arrow-trending-lines'){
          return '0 0 24 30'
        }
        return '0 0 24 24'
    },

    onChildClick(childItem) {
      if (childItem.to.includes('pipelines/boards/')) {
        const parts = childItem.to.split('/');
        const accountIdIndex = parts.indexOf('accounts') + 1;
        const accountId = parts[accountIdIndex];
        const boardId = parts.pop();
        
        if (accountId && boardId) {
          const existingAccountPrefs = this.uiSettings?.user_preferences_by_account || {};
          const currentAccountPrefs = existingAccountPrefs[accountId] || {};

          this.updateUISettings({
            user_preferences_by_account: {
              ...existingAccountPrefs,
              [accountId]: {
                ...currentAccountPrefs,
                last_board: String(boardId),
              },
            },
          });
        }
      }
    },
  },
};
</script>
<style scoped>
body:not(.dark) .color-blue {
  color: #40518A;
}

.active-class {
  background-color: #40518A !important;
  color: #fff !important;
}
body:not(.dark) .add-background {
  background-color: 	#cadcf1;
}
.pos{
  margin-top: 6px;
    margin-left: 8px;
}
</style>
